enum BuildType {
  development = 'DEVELOPMENT',
  production = 'PRODUCTION',
  test = 'TEST',
}

export const getBuildType = () => {
  const buildType =
    BuildType[import.meta.env.VITE_BUILD_TYPE as keyof typeof BuildType];
  if (!buildType) throw new Error('Build type is incorrectly set');
  return buildType;
};

export const isDevelopmentBuild = () => {
  return getBuildType() === BuildType.development;
};

export const isProductionBuild = () => {
  return getBuildType() === BuildType.production;
};

export const isTestBuild = () => {
  return getBuildType() === BuildType.test;
};

const developmentHostname = 'my.helu.ninja';
const localHostname = 'localhost';
const previewHostname = 'preview.v2.helu.ninja';
const stagingHostname = 'my.staging.helu.ninja';
const productionHostname = 'app.helu.io';

enum Environment {
  local = 'local',
  development = 'development',
  preview = 'preview',
  staging = 'staging',
  production = 'production',
  test = 'test',
}

export const getWindowLocationEnvironment = () => {
  const { hostname } = window.location;
  if (hostname.includes(productionHostname)) return Environment.production;
  if (hostname.includes(stagingHostname)) return Environment.staging;
  if (hostname.includes(previewHostname)) return Environment.preview;
  if (hostname.includes(developmentHostname)) return Environment.development;
  if (hostname.includes(localHostname)) return Environment.local;
  return Environment.test;
};

export const isLocalEnvironment = () => {
  return getWindowLocationEnvironment() === Environment.local;
};

export const isDevelopmentEnvironment = () => {
  return getWindowLocationEnvironment() === Environment.development;
};

export const isProductionEnvironment = () => {
  return getWindowLocationEnvironment() === Environment.production;
};

export const isPreviewEnvironment = () => {
  return getWindowLocationEnvironment() === Environment.preview;
};

export const isStagingEnvironment = () => {
  return getWindowLocationEnvironment() === Environment.staging;
};

export const isTestEnvironment = () => {
  return getWindowLocationEnvironment() === Environment.test;
};
